import { useState, useEffect } from 'react';

export const useWindowWidth = (): { width: number } => {
  const [width, setWidth] = useState<number>(0);

  useEffect(() => {
    setWidth(document.documentElement.clientWidth);

    let animationFrameId: number;

    const observer = new ResizeObserver(entries => {
      cancelAnimationFrame(animationFrameId);
      animationFrameId = requestAnimationFrame(() => {
        setWidth(entries[0].contentRect.width);
      });
    });

    observer.observe(document.documentElement);

    return (): void => {
      cancelAnimationFrame(animationFrameId);
      observer.disconnect();
    };
  }, []);

  return { width };
};
